"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var formatter_1 = require("../../utils/formatter");
var Query_1 = require("../Query");
var object_1 = require("../../utils/object");
var FormatTransform = /** @class */ (function (_super) {
    __extends(FormatTransform, _super);
    function FormatTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormatTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        var formatTransformOptions = this.options.formatTransformOptions;
        if (formatTransformOptions) {
            var originalFormat = formatTransformOptions.format, currencyQueryOptions = formatTransformOptions.currencyQuery;
            var format = originalFormat;
            if (format) {
                var currency = executionOptions.currency, culture = executionOptions.culture, translate = executionOptions.translate;
                if (format.globalFormatKey) {
                    var globalFormat = executionOptions && executionOptions.globalFormatsByKey && executionOptions.globalFormatsByKey[format.globalFormatKey];
                    if (globalFormat && globalFormat.format) {
                        format = object_1.deepMergeObjects(globalFormat.format, format);
                    }
                }
                var type = format.type, transforms = format.transforms;
                var workingCurrency = currency;
                if (currencyQueryOptions) {
                    var currencyQuery = new Query_1.Query(currencyQueryOptions);
                    workingCurrency = currencyQuery.execute(executionOptions);
                }
                response = formatter_1.default(type, culture, workingCurrency, format.options, queryResponse, transforms, translate);
            }
        }
        return response;
    };
    return FormatTransform;
}(BaseTransform_1.BaseTransform));
exports.FormatTransform = FormatTransform;
//# sourceMappingURL=FormatTransform.js.map